export type CardType = "idea" | "note" | "link" | "movie" | "recipe" | "place" | "task" | "material" | "video";

export interface CardAttachment {
  id: string;
  filename: string;
  mime_type: string;
  size_bytes: number;
  role: "original" | "cover";
}

export interface MemoryCard {
  id: string;
  type: CardType;
  title: string;
  original_text: string;
  summary: string;
  source_url: string | null;
  source_kind: string;
  event_start: string | null;
  event_end: string | null;
  status: "processing" | "ready" | "failed";
  archived_at: string | null;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  metadata: Record<string, unknown>;
  tags: string[];
  entities: Array<{ kind: string; name: string }>;
  attachments: CardAttachment[];
}

export interface Reminder {
  id: string;
  card_id: string | null;
  message: string;
  rrule: string | null;
  timezone: string;
  next_run_at: string;
  status: "active" | "paused" | "completed" | "cancelled";
}

export interface VideoDetails {
  card_id: string;
  platform: "youtube";
  external_video_id: string;
  channel_name: string;
  channel_url: string | null;
  duration_seconds: number;
  original_language: string | null;
  watch_status: "to_watch" | "watched";
  transcript_status: "pending" | "native" | "generated" | "approval_required" | "failed";
  provider_job_id: string | null;
  error_code: string | null;
  updated_at: string;
}

export interface TranscriptChunk {
  text: string;
  startMs: number | null;
  endMs: number | null;
}

export interface GraphData {
  cards: Array<{ id: string; type: CardType; title: string; created_at: string }>;
  relationships: Array<{
    source_card_id: string;
    target_card_id: string;
    relation_type: string;
    explanation: string;
    confidence: number;
  }>;
}

export const CARD_LABELS: Record<CardType, string> = {
  idea: "Идея",
  note: "Заметка",
  link: "Ссылка",
  movie: "Фильм / сериал",
  recipe: "Рецепт",
  place: "Место",
  task: "Задача",
  material: "Книга / материал",
  video: "Видео",
};
